import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/icons/icon-search.svg'


const _hoisted_1 = { class: "input-search-wrapper" }
const _hoisted_2 = ["value", "placeholder"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", {
      class: _normalizeClass(["input-search-wrapper__icon", `input-search-wrapper__icon--${$setup.props.theme}`])
    }, [...(_cache[1] || (_cache[1] = [
      _createElementVNode("img", { src: _imports_0 }, null, -1)
    ]))], 2),
    _createElementVNode("input", {
      class: _normalizeClass(`input-search--${$setup.props.theme}`),
      value: $setup.props.modelValue,
      onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:modelValue', $event.target.value))),
      placeholder: $setup.props.placeholder
    }, null, 42, _hoisted_2)
  ]))
}